import { render } from "./ClientForm.vue?vue&type=template&id=514a1ee8"
import script from "./ClientForm.vue?vue&type=script&lang=js"
export * from "./ClientForm.vue?vue&type=script&lang=js"
script.render = render

export default script